import React from 'react';
import BBDataTable from "../tables/BBDataTable";
import {useSelector} from "react-redux";
import {    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf, bbFormattedDateString, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BRSocialTestEventsModal from "./BRSocialTestEventsModal";
import BBIconPaperClipThin from "../../../assets/bbCustomIcons/BBIconPaperClipThin";
import BBIconHyperlink from "../../../assets/bbCustomIcons/BBIconHyperlinkRound";
import BRSocialIdentitiesDetailsModal from "./BRSocialIdentitiesDetailsModal";
import BBExternalLink from "../accents/BBExternalLink";
import PremiumCustomersOnlyWrapper from "./PremiumCustomersOnlyWrapper";

const BRSocialTestsTable = ({modalDisplay = false,
                                modalTests= null,
                                cycleId = null,
                                portfolioView=false,
})=>{

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycles, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const isAdmin = isCurrentUserMemberOf(authUser, "admin");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    // const userHasAccess = (isAdmin || myEntity.pro_subscription || myEntity.premium_subscription)
    const entityHasSocialOn = myEntity && myEntity.settings && myEntity.settings.social_testing_authorized;

    const lastCycle = myEntity ? myEntity.last_cycle : null
    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;
    const cycleIdToUse = cycleId ? cycleId : lastCycleId;

    const identitiesObject = myEntity
        && myEntity.cycles
        && myEntity.cycles[cycleIdToUse]
        && myEntity.cycles[cycleIdToUse].social
        && myEntity.cycles[cycleIdToUse].social.identities;

    const social = myEntity
        && myEntity.cycles
        && cycleIdToUse
        && myEntity.cycles[cycleIdToUse]
        // && !loadingCycleSocial[cycleIdToUse]
        && myEntity.cycles[cycleIdToUse].social;

    const numTestsSent = cycleIdToUse
    && social
    && social.cycleTotals
    && social.cycleTotals.number_social_tests
        ? social.cycleTotals.number_social_tests
        : 0;

    const socialTests = myEntity
        && myEntity.cycles
        && myEntity.cycles[cycleIdToUse]
        && myEntity.cycles[cycleIdToUse].social
        && myEntity.cycles[cycleIdToUse].social.socialTests
            ? myEntity.cycles[cycleIdToUse].social.socialTests
            : {};

    const title = <div className={"tourSocialIdentitiesTable"} id={"tourPhishingTestResponseTable"}>
        Phishing Test Response
    {/*    <Tooltip title={""}>*/}
    {/*    <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>*/}
    {/*</Tooltip>*/}
    </div>;

    const description = <>Details of each phishing attempt, along with details of opens, clicks, and code execution.</>


    const userTableHeadings=[
        { field: 'id', headerName: 'ID', hide: true, flex : .5, sortable: true, type: 'string', renderCell: (params) => {
                return params.value}},
        { field: 'sentDate', headerName: 'Sent', hide: false, width: 100, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "--"}
                    </span>
                </Tooltip>))},
        { field: 'emailAddress', headerName: 'Sent To', hide: modalDisplay, flex : 0.85, sortable: true, type: 'string', cellClassName: "tourStepIdentitiesCol",
            renderHeader: (params)=> <span  id={"tourStepIdDetailsHeader"}>Sent To</span> ,
            renderCell: (params) =>
                renderCellExpand(params, (
                    // <Tooltip title={`${params.row.identity.first ? params.row.identity.first : "  "}
                    // ${params.row.identity.last ? params.row.identity.last : "  "}  ${params.row.identity.last ? " : " : "  "}
                    // ${params.row.identity.position ? params.row.identity.position : " "}`}>
                        <span className={"text-center"}>
                            <BRSocialIdentitiesDetailsModal identityId={params.row.tested_identity.id} sentToAddress={params.value}/>
                        </span>
                    // </Tooltip>
                        ))},
        { field: 'templateSubject', headerName: 'Email Subject', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                        <span>
                            {params.value ? params.value : "---"}
                        </span>
                    </Tooltip>))},
        { field: 'templateSenderEmail', headerName: 'Sent From', hide: false, flex : 0.7, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                        <code>
                            {params.value ? params.value : "---"}
                        </code>
                    </Tooltip>))},
        // { field: 'sent', headerName: 'Sent', hide: false, sortable: true, type: 'string', width: 110,
        //     renderHeader: (params) => <Tooltip title={"Displays if the email was successfully sent."}>
        //         <span>Sent</span>
        //     </Tooltip>,
        //     renderCell: (params) =>
        //         renderCellExpand(params, (<>
        //                 {params.value
        //                     ? <Tooltip title={`Email successfully sent.`}>
        //                           <span className={"text-center"}>
        //                             <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
        //                           </span>
        //                     </Tooltip>
        //                     : <Tooltip title={`Email was not sent.`}>
        //                           <span className={"text-center"}>
        //                             <BBIconRoundedDashNull/>
        //                           </span>
        //                     </Tooltip>
        //                 }
        //             </>
        //
        //         ))},
        { field: 'hasTemplatePayload', headerName: 'Type of Attack', hide: false, sortable: true, type: 'string', width: 75,
            renderHeader: (params) => <Tooltip title={"Displays Type of Attack Used."}>
                <span>Type</span>
            </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.row.hasTemplateFile
                            ? <Tooltip title={`Attack contained a downloadable file.`}>
                                  <span className={"text-center"}>
                                    <BBIconPaperClipThin className={'text-bb-risk-low'}/>
                                      <p className={"m-0 p-0 align-self-center"}><small>Attachment</small></p>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`Attack contained a clickable link.`}>
                                  <span className={"text-center"}>
                                    <BBIconHyperlink className={'text-bb-risk-low'}/>
                                      <p className={"m-0 p-0 align-self-center"}><small>Link</small></p>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'opened', headerName: 'Opened', hide: false, sortable: true, type: 'boolean', width: 100,
            renderHeader: (params) => <Tooltip title={"Opened means that we detected the spearphishing email was opened by the recipient. Note: Some security controls may prevent us from detecting this activity, so the actual number of opens may be higher."}>
                <span id={"tourStepResponseIcons"}>Opened</span>
            </Tooltip>, cellClassName: "tourStepResponseCol",
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Opened means that we detected the spearphishing email was opened by the recipient.`}>
                                  <span className={"text-center"}>
                                    <BBIconCheckCircleYes className={'text-bb-risk-medium'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`This test email was not opened. Note: Some security controls may prevent us from detecting this activity, so the actual number of opens may be higher.`}>
                                  <span className={"text-center"}>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},

        { field: 'executed', headerName: 'Executed', hide: false, sortable: true, type: 'boolean', width: 105, renderHeader: (params) =>
                <Tooltip title={"Executed means that we were able to execute an attack process on the recipient's host using the spearphishing payload. Some security controls can prevent this code execution, and even successfully executed payloads might not cause a breach."}>
                <span>Executed</span>
            </Tooltip>, cellClassName: "tourStepResponseCol",
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Executed means that we were able to execute an attack process on the recipient's host using the spearphishing payload. `}>
                                  <span className={"text-center"}>
                                    <BBIconCheckCircleYes className={'text-bb-risk-high'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`This test did not result in any executed eventsExecuted means that we were able to execute an attack process on the recipient's host using the spearphishing payload. .`}>
                                  <span className={"text-center"}>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'success', headerName: 'Breached', hide: false, sortable: true, type: 'boolean', width: 105, renderHeader: (params) =>
                <Tooltip title={"Breached means that, as a result of spearphishing code execution, we were able to achieve initial access to the recipient's host. Some successfully executed payloads may not cause a breach due to configurations or security controls."}>
                <span>Breached</span>
            </Tooltip>, cellClassName: "tourStepResponseCol",
            renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Breached means that, as a result of spearphishing code execution, we were able to achieve initial access to the recipient's host.`}>
                                  <span className={"text-center"}>
                                    <BBIconCheckCircleYes className={'text-bb-risk-highest'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`No breaches were achieved from this test.Breached means that, as a result of spearphishing code execution, we were able to achieve initial access to the recipient's host.`}>
                                  <span className={"text-center"}>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'numOfEvents', headerName: 'Details', hide: false, disableExport: true, filterable: false, type: 'string', width: 110, cellClassName: "tourStepResponseDetailsCol",
            renderHeader: (params)=> <span id={"tourStepDetailsHeader"}>Details</span>,
            renderCell: (params) =>
                renderCellExpand(params, (<>
                    {modalDisplay ? <BRSocialTestEventsModal testObj={params.row}/> : <BRSocialTestEventsModal testId={params.row.id} cycleId={cycleIdToUse}/>}
                    </>

                ))},

    ]


    const testsToUse = modalDisplay
        ? modalTests : socialTests;

    // console.log("testsToUse", testsToUse)

    const socialTestsArray = testsToUse && Object.values(testsToUse).map((test)=>{
        return {
            ...test,
            templateId: test.template.id,
            templateSenderEmail: test.template.social_account.email,
            templateSenderName: test.template.social_account.sender_name,
            templateSubject: test.template.subject,
            hasTemplatePayload: test.template.link_payload ? "link" : "downloadable file",
            hasTemplateLink: test.template.link_payload,
            hasTemplateFile: test.template.file_payload,
            identity: identitiesObject[test.tested_identity.id],
            emailAddress: test.tested_identity.email,
            sentDate: bbFormattedDateString(test.sent_datetime, "short"),
            numOfEvents: Object.keys(test.executed_events).length + Object.keys(test.opened_events).length,

        }
    });

    socialTestsArray && socialTestsArray.sort((a,b)=> b.numOfEvents - a.numOfEvents);

    return(
        <div>
            { (socialTestsArray || numTestsSent === 0)
            // && myEntity
            // && myEntity.cycles
            // && myEntity.cycles[cycleIdToUse]
            && !loadingCycles[cycleIdToUse]
            // && !loadingCycleSocial[cycleIdToUse]
                ?
                <BBDataTable
                    columns={userTableHeadings}
                    rows={socialTestsArray}
                    title={!modalDisplay ? title: null}
                    description={description}
                    loading = {socialTestsArray && numTestsSent !== 0 && socialTestsArray.length !== numTestsSent}
                    progressValue={100}
                    enableExport={!modalDisplay}
                    disableColumnSelector={modalDisplay}
                    disableDensitySelector={modalDisplay}
                    disableColumnMenu={modalDisplay}
                    disableColumnFilter={modalDisplay}
                    defaultSortModel={[
                            {field: 'numOfEvents', sort: 'desc'},
                        ]}
                    premium={true}
                    requiresBRLevel={portfolioView ? "infoLevel4" : "infoLevel3"}
                />
                :
                <BBDataTable
                    columns={userTableHeadings}
                    rows={[]}
                    description={description}
                    title={title}
                    loading = {true}
                    progressValue={0}
                    bufferValue={15}
                    premium={true}
                />
            }
        </div>
    )
}

export default BRSocialTestsTable;